import React from 'react';
import { Factory, Users, Award, TrendingUp } from 'lucide-react';

const About = () => {
  const stats = [
    { icon: Factory, label: 'Manufacturing Plants', value: '3+' },
    { icon: Users, label: 'Happy Customers', value: '10,000+' },
    { icon: Award, label: 'Years of Excellence', value: '25+' },
    { icon: TrendingUp, label: 'Growth Rate', value: '15%' }
  ];

  return (
    <section id="about" className="py-12 md:py-20 bg-gradient-to-br from-amber-50 to-yellow-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-amber-800 mb-4 md:mb-6">
            About Simran Industries
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed px-2">
            Leading the animal nutrition industry with premium quality cotton seed cake
            and cattle feed products manufactured in Indore, Madhya Pradesh.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center mb-12 md:mb-16">
          <div className="space-y-4 md:space-y-6 order-2 lg:order-1">
            <h3 className="text-2xl sm:text-3xl font-bold text-amber-800">
              Our Legacy of Excellence
            </h3>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              Since 1995, Simran Industries has been at the forefront of animal nutrition,
              manufacturing high-quality cotton seed cake and specialized cattle feed.
              Based in the heart of India's agricultural hub - Indore, we serve dairy
              farmers and livestock owners across the nation.
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              Our commitment to quality, purity, and nutritional excellence has made us
              a trusted partner for thousands of dairy farms. We combine traditional
              knowledge with modern manufacturing processes to deliver superior products
              that enhance milk production and animal health.
            </p>
            <div className="bg-gradient-to-r from-amber-100 to-yellow-100 p-4 md:p-6 rounded-xl border-l-4 border-amber-500">
              <p className="text-amber-800 font-semibold text-base md:text-lg italic">
                "Quality is not an act, it is a habit. We ensure every batch meets
                the highest standards of purity and nutrition."
              </p>
              <p className="text-amber-700 mt-2 text-sm md:text-base">- Simran Industries Quality Promise</p>
            </div>
          </div>

          <div className="relative order-1 lg:order-2 h-64 sm:h-80 md:h-96 lg:h-[500px]">
            <img
              src="https://images.pexels.com/photos/1459505/pexels-photo-1459505.jpeg"
              alt="Modern cattle feed manufacturing facility"
              className="rounded-2xl shadow-2xl w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-2xl"></div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 gap-3 sm:gap-4 md:gap-8 md:grid-cols-4">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group">
              <div className="bg-white rounded-lg sm:rounded-2xl p-3 sm:p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105">
                <div className="inline-flex items-center justify-center w-12 sm:w-16 h-12 sm:h-16 bg-gradient-to-r from-amber-500 to-yellow-500 rounded-full mb-2 sm:mb-4">
                  <stat.icon className="text-white" size={20} />
                </div>
                <h4 className="text-2xl sm:text-3xl font-bold text-amber-800 mb-1 sm:mb-2">{stat.value}</h4>
                <p className="text-xs sm:text-sm md:text-base text-gray-600 font-medium">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;